// Word-level LCS diff used by the live-doc pane to mark what each decision
// changed.

export interface DiffOp { t: "keep" | "add" | "del"; s: string }

export function diffWords(oldS: string, newS: string): DiffOp[] {
  const a = oldS ? oldS.split(/(\s+)/).filter((x) => x !== "") : [];
  const b = newS ? newS.split(/(\s+)/).filter((x) => x !== "") : [];
  const n = a.length, m = b.length;
  if (n * m > 4e6) return [{ t: "add", s: newS }];   // degenerate guard
  const dp = new Uint16Array((n + 1) * (m + 1));
  const at = (i: number, j: number) => dp[i * (m + 1) + j]!;
  for (let i = n - 1; i >= 0; i--)
    for (let j = m - 1; j >= 0; j--)
      dp[i * (m + 1) + j] = a[i] === b[j] ? at(i + 1, j + 1) + 1 : Math.max(at(i + 1, j), at(i, j + 1));
  const ops: DiffOp[] = [];
  let i = 0, j = 0;
  while (i < n && j < m) {
    if (a[i] === b[j]) { ops.push({ t: "keep", s: b[j]! }); i++; j++; }
    else if (at(i + 1, j) >= at(i, j + 1)) { ops.push({ t: "del", s: a[i]! }); i++; }
    else { ops.push({ t: "add", s: b[j]! }); j++; }
  }
  while (i < n) ops.push({ t: "del", s: a[i++]! });
  while (j < m) ops.push({ t: "add", s: b[j++]! });
  return ops;
}
